export const formatCurrency = (amount) => {
  const num = parseFloat(amount || 0);
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(num);
};

// Format date in New York timezone to avoid timezone conversion issues
// When dates are stored as strings like "2025-12-07", we want to display them
// as that exact date, not converted from UTC which causes off-by-one day errors
export const formatDateInNY = (dateStr) => {
  if (!dateStr) return 'N/A';
  
  // If dateStr is already a Date object, convert it to a date string first
  let dateString;
  if (dateStr instanceof Date) {
    // Get the date parts in New York timezone
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    });
    const parts = formatter.formatToParts(dateStr);
    const month = parts.find(p => p.type === 'month')?.value;
    const day = parts.find(p => p.type === 'day')?.value;
    const year = parts.find(p => p.type === 'year')?.value;
    return `${month}/${day}/${year}`;
  } else {
    // For date strings like "2025-12-07", parse directly to avoid UTC conversion
    dateString = dateStr.split('T')[0]; // Remove time portion if present
    const [year, month, day] = dateString.split('-').map(Number);
    
    // Format as M/D/YYYY (US format)
    return `${month}/${day}/${year}`;
  }
};

export const formatDate = (dateStr) => {
  if (!dateStr) return 'N/A';
  const date = new Date(dateStr);
  return date.toLocaleDateString('en-US', { 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric',
    timeZone: 'America/New_York'
  });
};

export const calculateTotalHours = (paystubData) => {
  return parseFloat(paystubData.total_hours || 0);
};

export const calculateNetPay = (paystubData) => {
  const grossPay = parseFloat(paystubData.total_pay || 0);
  const deductions = parseFloat(paystubData.employee_deductions || 0);
  const taxes = parseFloat(paystubData.employee_taxes || 0);
  return grossPay - deductions - taxes;
};

export const getPayPeriodDates = (payPeriodStr) => {
  if (!payPeriodStr) return { start: null, end: null };
  
  // Assuming format like "2024-01-01 to 2024-01-14"
  const parts = payPeriodStr.split(' to ');
  if (parts.length === 2) {
    return {
      start: new Date(parts[0]),
      end: new Date(parts[1])
    };
  }
  
  return { start: null, end: null };
};

export const generateWeekDates = (startDate, weekNumber) => {
  const dates = [];
  const start = new Date(startDate);
  
  // Move to the start of the specified week
  start.setDate(start.getDate() + (weekNumber - 1) * 7);
  
  for (let i = 0; i < 7; i++) {
    const date = new Date(start);
    date.setDate(start.getDate() + i);
    dates.push(date);
  }
  
  return dates;
};